// We only need to import the modules necessary for initial render
import CoreLayout from "../layouts/CoreLayout/CoreLayout"
import WelcomeView from "./WelcomeView"
import Login from "./Login"
import ForgotPassword from "./ForgotPassword"

import {UserIsAdminOrOps, UserIsAuthenticated, UserIsEnterprise} from "./AuthWrappers"
import DashboardView from "./cogoland/DashboardView"
import AccessDeniedView from "./AccessDeniedView"
import AdminView from "./enterprise/AdminView"
import EnterpriseAccountView from "./admin/EnterpriseAccountView"
import UpdateEnterpriseAccountView from "./admin/UpdateEnterpriseAccountView"
import CreateEnterpriseAccountView from "./admin/CreateEnterpriseAccountView"
import EnterpriseCogolandUserReportView from "./cogoland/EnterpriseCogolandUserReportView"

/*  Note: Instead of using JSX, we recommend using react-router
 PlainRoute objects to build route definitions.   */

const AuthenticatedComponents = UserIsAuthenticated(
  (props) => {
    return props.children
  }
);

export const createRoutes = (store) => (
  [
    Login,
    ForgotPassword,
    {
      path: '/enterprise/cogoland/users/:reportName/:id',
      component: UserIsEnterprise(EnterpriseCogolandUserReportView)
    },
    {
      path: '/',
      component: CoreLayout,
      indexRoute: { onEnter: (nextState, replace) => replace('/welcome') },
      childRoutes: [

        {
          component: AuthenticatedComponents,
          childRoutes: [
            {
              path: '/welcome',
              component: UserIsAuthenticated(WelcomeView)
            },
            {
              path: '/accessDenied',
              component: UserIsAuthenticated(AccessDeniedView)
            },
            {
              path: '/dashboard',
              component: UserIsEnterprise(DashboardView)
            },
            {
              path: '/users',
              component: UserIsEnterprise(AdminView)
            },
            {
              path: '/admin/enterprise',
              component: UserIsAdminOrOps(EnterpriseAccountView)
            },
            {
              path: '/admin/createEnterpriseAccount',
              component: UserIsAdminOrOps(CreateEnterpriseAccountView)
            },
            {
              path: '/admin/updateEnterpriseAccount',
              component: UserIsAdminOrOps(UpdateEnterpriseAccountView)
            }
          ]
        }
      ]
    },




  ])


export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js